module.exports = __webpack_public_path__ + "static/pranoppal-ce40b3ccfe03e621b66eb64594cfd993.jpeg";